import type { IAdminCompanyRow } from '@commenda/api/admin';
import { BulkSendCompanyMessageResultItem } from '@commenda/api/chatRoom';

function sanitizeCsvCell(value: string): string {
  if (/^[=+\-@\t\r]/.test(value)) {
    return `'${  value}`;
  }
  return value;
}

export function downloadFailedCompanyCsv(
  failedResults: BulkSendCompanyMessageResultItem[],
  companies: IAdminCompanyRow[],
  sentMessage: string
) {
  const headers = ['Company ID', 'Company Name', 'Email', 'Account Manager', 'Message', 'Error Message'];
  const rows = failedResults.map((result) => {
    const company = companies.find((c) => c.id === result.companyId);
    return [
      String(result.companyId),
      company?.displayName ?? '',
      company?.email ?? '',
      company?.handler?.name ?? '',
      sentMessage,
      result.error ?? 'Unknown error',
    ];
  });

  const csvContent = [headers, ...rows]
    .map((row) =>
      row.map((cell) => `"${sanitizeCsvCell(String(cell).replace(/"/g, '""'))}"`).join(',')
    )
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `failed-mass-messages-companies-${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
}
